var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.doNotRender)?_c('div',{ref:"map",style:(_vm.styleProps)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }